import {Palette} from 'hubbl-shared';
import {AssetIconProps} from '../types';
import {memo} from 'react';

export const AssetIconResetTime = memo(
  ({size = 24, color = Palette.almostBlack}: AssetIconProps) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.52503 5.39414C7.19427 3.75776 9.4787 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C9.4787 21.25 7.19427 20.2422 5.52503 18.6059C5.22924 18.3159 4.75439 18.3206 4.46443 18.6164C4.17446 18.9122 4.17918 19.387 4.47497 19.677C6.41323 21.5771 9.0704 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C9.07039 1.25 6.41323 2.42288 4.47497 4.32299C4.17918 4.61296 4.17446 5.08781 4.46443 5.3836C4.75439 5.67939 5.22924 5.68411 5.52503 5.39414ZM12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V12C11.25 12.2508 11.3753 12.4849 11.584 12.624L14.584 14.624C14.9286 14.8538 15.3943 14.7607 15.624 14.416C15.8538 14.0714 15.7607 13.6057 15.416 13.376L12.75 11.5986V8Z"
          fill={color}
        />
        <path
          d="M5.50021 2L5.00021 5H8.00021"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
);
